import React from 'react';

import './index.scss'

const ButtonSubmit = ({title}) => {
    return (
        <div className="form-btn-wrapper">
            <button className="cashnow--main__btn">{title}</button>
        </div>
    )
}

export default ButtonSubmit;